import React, { memo, useCallback } from 'react';
import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { trackButtonClick } from '../../utils/gtm';
import { DEMO_BOOKING_EMBED_URL } from '../../constants/demoBooking';

const DemoBookingModal = ({ open, onClose, gtmLocation }) => {
  const handleClose = useCallback(() => {
    if (gtmLocation) {
      trackButtonClick('close_demo_modal', gtmLocation);
    }
    onClose();
  }, [gtmLocation, onClose]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: 'hidden',
        },
      }}
    >
      <IconButton
        onClick={handleClose}
        aria-label="Close booking modal"
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          zIndex: 1,
          bgcolor: 'rgba(255, 255, 255, 0.9)',
          '&:hover': {
            bgcolor: 'rgba(255, 255, 255, 1)',
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      <iframe
        title="Book a Sniffr demo"
        src={DEMO_BOOKING_EMBED_URL}
        style={{ minWidth: '320px', width: '100%', height: '580px', border: 0 }}
        allowFullScreen
      />
    </Dialog>
  );
};

export default memo(DemoBookingModal);
